import { Page } from "@tfg/ui"
import { Navigate } from "react-router-dom"

import { useAuth } from "~/store/auth-context"

export const HomeWrapper = () => {
  const { user } = useAuth()
  if (!user) {
    return <Navigate to="/login" replace={true} />
  }
  if (!user.organization) {
    return <Navigate to="/supplier/requests" replace={true} />
  }
  return <Page title="Dashboard" />
}
